import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[user-dlg-func]'
})
export class UserDlgFuncDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}